import JobSharing from '../modules/components/jobs/sharing';
import JobCloseForm from '../modules/forms/jobs/close';
import JobApplyForm from '../modules/forms/jobs/apply';
import JobLeaveForm from '../modules/forms/jobs/leave';
import JobAcceptForm from '../modules/forms/jobs/accept';
import JobPayForm from '../modules/forms/jobs/pay';
import JobFinishForm from '../modules/forms/jobs/finish';
import JobCommissionForm from '../modules/forms/jobs/commission';
import JobReview from '../modules/components/jobs/review';
import JobReviewForm from '../modules/forms/jobs/review';

import JobsAdminPanel from '../modules/components/jobs/admin-panel';

export default function setJobsScripts () {
    if (!window.location.pathname.includes('/jobs/')) return;

    const path = window.location.pathname;

    const routes = {
        single: () => path.split('/').length > 3
    };

    if (!Object.values(routes).some((route) => route())) return;

    // Sharing

    if (routes.single()) {
        new JobSharing();

        ['DOMContentLoaded', 'resize', 'orientationchange'].forEach((event) => {
            window.addEventListener(event, () => {
                const aside = document.querySelector('.site-job__aside');
                const mobile = document.querySelector('#mobile-aside-placement');
                const desktop = document.querySelector('#desktop-aside-placement');

                if (window.innerWidth <= 991) {
                    mobile.append(aside);
                } else {
                    desktop.append(aside);
                }
            });
        });

        new JobsAdminPanel();
    }

    if (routes.single()) {
        if (document.querySelector('#close-job-form')) new JobCloseForm('#close-job-form');
        if (document.querySelector('#apply-job-form')) new JobApplyForm('#apply-job-form');
        if (document.querySelector('#leave-job-form')) new JobLeaveForm('#leave-job-form');
        if (document.querySelector('#accept-job-form')) new JobAcceptForm('#accept-job-form');
        if (document.querySelector('#pay-job-form')) new JobPayForm('#pay-job-form');
        if (document.querySelector('#finish-job-form')) new JobFinishForm('#finish-job-form');
        if (document.querySelector('#commission-job-form')) new JobCommissionForm('#commission-job-form');
        if (document.querySelector('#review-job-form')) {
            new JobReview('#review-job-form');

            new JobReviewForm('#review-job-form');
        }
    }
}
